import { createSlice } from "@reduxjs/toolkit";

const defaultCompConf = {
    id: "-1",
	companyID: "",
	productID: "",
	contractStartDate: "1970-01-01T00:00:00",
	contractEndDate: "1970-01-01T00:00:00",
	lastUpdate: "1970-01-01T00:00:00",
	companyName: "",
	subModules: [],
	configurations: [],
    isRefreshConfs: false,
    isChangesMade: false
};

export const companyConfSlice = createSlice({
    name: "companyConf",
    initialState: defaultCompConf,
    reducers: {
        setCompanyConf: (state, action) => {
            return {
                ...action.payload,
                isRefreshConfs: true,
                isChangesMade: false
            };
        },
        resetCompanyConf: (state) => {
            return {
                ...defaultCompConf,
                isRefreshConfs: true,
                isChangesMade: false
            };
        },
        setCompanyId: (state, action) => {
            return {
                ...state,
                companyID: action.payload,
                isChangesMade: true
            };
        },
        addConf: (state) => {
            let confs;
            
            if (state.configurations !== undefined && state.configurations !== null) {
                confs = state.configurations.map((row) => row);
            } else {
                confs = [];
            }
            
            const confIndex = confs.findIndex((row) => 
                row.key === "" && row.value === ""
            );

            if (confIndex >= 0) {
                return {
                    ...state
                };
            }

            confs.push({
                key: "",
                value: ""
            });
            
            return {
                ...state,
                configurations: confs,
                isRefreshConfs: true,
                isChangesMade: true
            };
        },
        updateConf: (state, action) => {
            const {
                key,
                value,
                keyIndex
            } = action.payload;
            
            let confs;
            
            if (state.configurations !== undefined && state.configurations !== null) {
                confs = state.configurations.map((row) => row);
            } else {
                confs = [];
            }

            if (confs.length - 1 < keyIndex) {
                return {
                    ...state
                };
            }

            confs.splice(keyIndex, 1, {
                key: key,
                value: value
            });

            return {
                ...state,
                configurations: confs,
                isChangesMade: true
            };
        },
        deleteConf: (state, action) => {
            const keyIndex = action.payload;

            let confs;
            
            if (state.configurations !== undefined && state.configurations !== null) {
                confs = state.configurations.map((row) => row);
            } else {
                confs = [];
            }

            if (confs.length - 1 < keyIndex) {
                return {
                    ...state
                };
            }

            confs.splice(keyIndex, 1);

            return {
                ...state,
                configurations: confs,
                isRefreshConfs: true,
                isChangesMade: true
            };
        },
        updateContractStart: (state, action) => {
            const dt = new Date(action.payload);

            return {
                ...state,
                contractStartDate: dt.toJSON(),
                isChangesMade: true
            };
        },
        updateContractEnd: (state, action) => {
            const dt = new Date(action.payload);

            return {
                ...state,
                contractEndDate: dt.toJSON(),
                isChangesMade: true
            };
        },
        resetRefreshConfs: (state) => {
            return {
                ...state,
                isRefreshConfs: false
            };
        }
    }
});

export const {
    setCompanyConf,
    resetCompanyConf,
    addConf,
    updateConf,
    deleteConf,
    updateContractStart,
    updateContractEnd,
    resetRefreshConfs,
    setCompanyId
} = companyConfSlice.actions;

export default companyConfSlice.reducer;

export const companyConfSelector = (state) => state.companyConf;